<template>
  <div>
    <div class="iframe-container">
      <iframe
        src="https://lookerstudio.google.com/embed/reporting/7ca08809-2f48-42eb-b680-2a23f49cfbb1/page/sOhrF"
        allowfullscreen
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rekap",

  created() {
    document.title = "Rekap SNBT - BTA Group Management";
  }
};
</script>

<style scoped>
/* CSS agar tampilan iframe penuh dan tidak terpotong */
.iframe-container {
  width: 100%;
  height: 85vh; /* Menyesuaikan tinggi dengan layar */
  min-height: 600px;
}
.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/program-study/Rekap.vue